import { Configuration } from './models/configuration.model';

export class ConfigurationFactory {
    public static createConfigurationFromResponse(conf: Configuration): Configuration {
        return conf;
    }
}
